export default function cls(...values) {
	const arr = [];
	function add(...values) {
		values = values.filter(Boolean);
		if (values.length) arr.push(...values);
		return add;
	}
	add.join = () => arr.join(' ');
	return add(...values);
}